<div class="feedback-listing-container">
  <!-- Header -->
  <div class="page-header">
    <h1>Survey Feedbacks</h1>
    <p class="subtitle"></p>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="spinner"></div>
    <p>Loading surveys...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-container">
    <div class="error-icon">⚠️</div>
    <p>{{ error }}</p>
  </div>

  <!-- No Surveys State -->
  <div *ngIf="!loading && !error && surveys.length === 0" class="no-surveys">
    <div class="no-surveys-icon">📋</div>
    <h3>No Feedback Available</h3>
    <p>There are no surveys with feedback responses yet.</p>
  </div>

  <!-- Surveys Grid -->
  <div *ngIf="!loading && !error && surveys.length > 0" class="surveys-grid">
    <div 
      *ngFor="let survey of surveys" 
      class="survey-card"
      (click)="viewFeedbackDetail(survey.survey_id)"
    >
      <!-- Card Header -->
      <div class="card-header">
        <div class="survey-number-badge">{{ survey.survey_number }}</div>
        <span class="status-badge" [ngClass]="getStatusClass(survey.status)">
          {{ survey.status }}
        </span>
      </div>

      <!-- Card Body -->
      <div class="card-body">
        <h3 class="survey-title">{{ survey.survey_title }}</h3>
        <p class="survey-description" *ngIf="survey.survey_description">
          {{ survey.survey_description }}
        </p>
        <p class="created-date">
          <i class="far fa-calendar"></i>
          Created: {{ formatDate(survey.created_date_time) }}
        </p>
      </div>

      <!-- Card Footer -->
      <div class="card-footer">
        <div class="stats-row">
          <div class="stat-item">
            <div class="stat-icon">📊</div>
            <div class="stat-content">
              <div class="stat-label">Responses</div>
              <div class="stat-value">{{ survey.total_completed }}</div>
            </div>
          </div>

          <div class="stat-item">
            <div class="stat-icon">👥</div>
            <div class="stat-content">
              <div class="stat-label">Assigned</div>
              <div class="stat-value">{{ survey.total_assigned }}</div>
            </div>
          </div>
        </div>

        <div class="progress-section">
          <div class="progress-header">
            <span class="progress-label">Completion</span>
            <span class="progress-percentage" 
                  [ngClass]="getCompletionClass(survey.completion_percentage)">
              {{ survey.completion_percentage }}%
            </span>
          </div>
          <div class="progress-bar">
            <div class="progress-fill" 
                 [style.width.%]="survey.completion_percentage"
                 [ngClass]="getCompletionClass(survey.completion_percentage)">
            </div>
          </div>
        </div>

        <button class="view-btn">
          <i class="fas fa-eye"></i>
          View Feedback
        </button>
      </div>
    </div>
  </div>
</div>